module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "App",
    class: _vm.appClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    on: {
      "leave": _vm.routeLeave
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "home"
    }
  }, [_c('router-view', {
    on: {
      "updatedata": _vm.updateData,
      "updatestate": _vm.updateState
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Logo"
  }, [_c('svg', {
    staticClass: "Logo-use"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#fany-righi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Logo-baseline"
  }, [_vm._v("UI Design - Webdesign - Graphisme")])]), _vm._v(" "), _c('svg', {
    staticClass: "Defs",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "fany-righi-clip-path"
    }
  }, [_c('path', {
    attrs: {
      "d": "M38.4,39.3H35c-1,0-1.9-0.8-1.9-1.8l0,0v-3.3v-3.1c0-1,0.8-1.8,1.8-1.8H35h3.4V19.1C38.4,6.6,46.5,0,57.1,0 c5.3,0,10,2.2,11.8,3.7c0.6,0.5,0.8,1.4,0.4,2.2L65.9,12c-0.5,0.8-1.6,1-2.4,0.5c-1.8-1.1-3.8-1.8-5.9-1.9c-4.3,0-6.7,3.1-6.7,8.6 v10.2h10c1-0.1,1.8,0.7,1.9,1.7v0.1v6.4c0,1-0.9,1.8-1.9,1.8l0,0h-10v26.2c-0.1,1-0.9,1.8-1.9,1.8h-8.7c-1,0-1.8-0.8-1.9-1.8 C38.4,65.5,38.4,39.3,38.4,39.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,43.3c2.5,0,4.9,0.3,7.3,1c0.1-4.8-1.5-6.5-5.2-6.5c-3.8,0.1-7.5,0.5-11.2,1.4c-1.4,0.4-2.1-0.5-2.3-1.7l-0.9-4.9 c-0.3-1,0.2-2,1.2-2.3c0.1,0,0.1,0,0.2,0c4.4-1.2,9-1.8,13.6-1.8c12.5,0,15.4,6.2,15.4,16.5v20.6c-0.1,1-0.9,1.8-1.9,1.8h-3.6 c-0.8,0-1.5-0.6-1.7-1.3l-1.2-2.6c-3.3,3.1-7.7,4.9-12.2,4.8c-8,0-13.5-4.9-13.5-13C72,48.6,77.8,43.3,88,43.3 M88.2,60.2 c2.7-0.2,5.3-1.5,6.9-3.7v-5.2c-1.8-0.7-3.7-1.1-5.6-1.1c-3.9,0-6.5,2.1-6.5,5.1c0,2.7,2.1,4.9,4.8,4.9 C87.9,60.2,88.1,60.2,88.2,60.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.9,31.9c-0.4-0.8-0.1-1.8,0.7-2.3c0.3-0.2,0.6-0.2,1-0.2h9c0.7,0,1.4,0.4,1.7,1l10.1,21.4h0.1l10-21.4 c0.5-1,1.2-1,2.4-1h8c1.6,0,2.4,1.2,1.7,2.5L181,94.6c-0.3,0.7-1,1.1-1.7,1.1h-9.6c-0.9,0.1-1.8-0.5-1.9-1.5 c-0.1-0.4,0-0.8,0.2-1.1l15.2-28.5L167.9,31.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0,111.4c0-1,0.9-1.9,1.9-1.9l0,0h3.8c0.8,0,1.6,0.5,1.8,1.3l1.4,3.8c2.6-3.7,6.8-5.9,11.3-6c4.7,0,8.9,1.5,7.7,3.9 l-3.7,6.3c-0.4,0.8-1.4,1.2-2.3,0.9c-0.9-0.3-1.9-0.5-2.9-0.6c-2.9,0-5.6,1.5-7.1,4v23.6c0,1.4-0.9,1.8-2.3,1.8H1.9 c-1,0-1.9-0.9-1.9-1.9V111.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.1,110.4c0-1,0.9-1.9,1.9-1.9l0,0h9.3c1,0,1.9,0.9,1.9,1.9l0,0v36.2c0,1-0.9,1.8-1.9,1.9H40c-1-0.1-1.8-0.9-1.9-1.9 V110.4L38.1,110.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.5,133.5c-2-2.5-3.1-5.6-3-8.8c0-8.7,7.5-16.2,17.5-16.2h18.2c1-0.1,1.8,0.7,1.9,1.7v0.1v3.1c0,0.7-0.4,1.3-1.1,1.6 l-5.6,1.7c0,0,4,2.9,4,9.5c0,7.3-6.6,14.6-17.1,14.6c-3.8,0-6.4-0.7-8-0.7c-1.4,0-3.7,1.3-3.7,3.5c0,2,1.8,3.2,4,3.2h12.8 c9.1,0,16.5,4.8,16.5,13c0,8.6-7.4,15.8-21.9,15.8c-14.8,0-20.4-6.8-20.4-12.8c0-5.6,5-8.3,6-8.8v-0.3c-1.7-0.5-7.5-3-7.5-9.8 C64,136.6,71.5,133.4,71.5,133.5 M85.8,166.2c5.6,0,9.3-2.3,9.3-5.9c0-1.7-1.4-4.6-7.3-4.6c-2.2,0-4.3,0.1-6.5,0.4 c-1.2,0.4-4.3,1.7-4.3,4.6C77,164,80.4,166.2,85.8,166.2 M86.3,131.9c3.7,0,6.7-3,6.7-6.7s-3-6.7-6.7-6.7c-3.7-0.2-6.9,2.6-7.1,6.3 c-0.2,3.7,2.6,6.9,6.3,7.1C85.8,131.9,86,131.9,86.3,131.9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.5,81.6c0-1,0.8-1.8,1.8-1.8h8c1,0,1.8,0.8,1.8,1.8v29.1c2.9-2.1,6.4-3.2,10-3.2c12,0,16.9,9.4,16.9,19v18.4 c0,1-0.8,1.8-1.8,1.8h-7.6c-1,0-1.8-0.8-1.8-1.8v-18.4c0-5.3-2.9-8.6-7.5-8.6c-4.3,0-7.3,2.9-8.2,6.8V145c0.1,0.9-0.6,1.8-1.6,1.8 c-0.1,0-0.3,0-0.4,0h-7.8c-1,0-1.8-0.8-1.8-1.8L118.5,81.6L118.5,81.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.2,31.2c0-1,0.9-1.8,1.9-1.8l0,0h3.8c0.8,0,1.4,0.4,1.7,1.1L127,34c3.8-3.6,8.9-5.6,14.1-5.6c12.7,0,17.8,9,17.8,18.9 v30.2c-0.1,1-0.9,1.8-1.9,1.8h-8.2c-1,0-1.9-0.8-1.9-1.8l0,0V46.8c0-4.9-1.7-8.1-6.5-8.1c-4.1-0.1-7.8,2.3-9.4,6v20.8 c0,1.3-0.6,1.8-2.5,1.8h-8.4c-1,0-1.8-0.8-1.9-1.8L118.2,31.2L118.2,31.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.5,110.3c0-1,0.9-1.8,1.9-1.8l0,0h8.3c1,0,1.9,0.8,1.9,1.8l0,0V145c-0.1,1-0.9,1.8-1.9,1.8h-8.3c-1,0-1.8-0.8-1.9-1.8 V110.3L167.5,110.3z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "fany-righi-clip-path-ms"
    }
  }, [_c('path', {
    attrs: {
      "d": "M38.4,39.3H35c-1,0-1.9-0.8-1.9-1.8l0,0v-3.3v-3.1c0-1,0.8-1.8,1.8-1.8H35h3.4V19.1C38.4,6.6,46.5,0,57.1,0 c5.3,0,10,2.2,11.8,3.7c0.6,0.5,0.8,1.4,0.4,2.2L65.9,12c-0.5,0.8-1.6,1-2.4,0.5c-1.8-1.1-3.8-1.8-5.9-1.9c-4.3,0-6.7,3.1-6.7,8.6 v10.2h10c1-0.1,1.8,0.7,1.9,1.7v0.1v6.4c0,1-0.9,1.8-1.9,1.8l0,0h-10v26.2c-0.1,1-0.9,1.8-1.9,1.8h-8.7c-1,0-1.8-0.8-1.9-1.8 C38.4,65.5,38.4,39.3,38.4,39.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M88,43.3c2.5,0,4.9,0.3,7.3,1c0.1-4.8-1.5-6.5-5.2-6.5c-3.8,0.1-7.5,0.5-11.2,1.4c-1.4,0.4-2.1-0.5-2.3-1.7l-0.9-4.9 c-0.3-1,0.2-2,1.2-2.3c0.1,0,0.1,0,0.2,0c4.4-1.2,9-1.8,13.6-1.8c12.5,0,15.4,6.2,15.4,16.5v20.6c-0.1,1-0.9,1.8-1.9,1.8h-3.6 c-0.8,0-1.5-0.6-1.7-1.3l-1.2-2.6c-3.3,3.1-7.7,4.9-12.2,4.8c-8,0-13.5-4.9-13.5-13C72,48.6,77.8,43.3,88,43.3 M88.2,60.2 c2.7-0.2,5.3-1.5,6.9-3.7v-5.2c-1.8-0.7-3.7-1.1-5.6-1.1c-3.9,0-6.5,2.1-6.5,5.1c0,2.7,2.1,4.9,4.8,4.9 C87.9,60.2,88.1,60.2,88.2,60.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.9,31.9c-0.4-0.8-0.1-1.8,0.7-2.3c0.3-0.2,0.6-0.2,1-0.2h9c0.7,0,1.4,0.4,1.7,1l10.1,21.4h0.1l10-21.4 c0.5-1,1.2-1,2.4-1h8c1.6,0,2.4,1.2,1.7,2.5L181,94.6c-0.3,0.7-1,1.1-1.7,1.1h-9.6c-0.9,0.1-1.8-0.5-1.9-1.5 c-0.1-0.4,0-0.8,0.2-1.1l15.2-28.5L167.9,31.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0,83.4c0-1,0.9-1.9,1.9-1.9l0,0h3.8c0.8,0,1.6,0.5,1.8,1.3l1.4,3.8c2.6-3.7,6.8-5.9,11.3-6c4.7,0,8.9,1.5,7.7,3.9 l-3.7,6.3c-0.4,0.8-1.4,1.2-2.3,0.9C21,91.4,20,91.2,19,91.1c-2.9,0-5.6,1.5-7.1,4v23.6c0,1.4-0.9,1.8-2.3,1.8H1.9 c-1,0-1.9-0.9-1.9-1.9V83.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.1,82.4c0-1,0.9-1.9,1.9-1.9l0,0h9.3c1,0,1.9,0.9,1.9,1.9l0,0v36.2c0,1-0.9,1.8-1.9,1.9H40c-1-0.1-1.8-0.9-1.9-1.9V82.4 L38.1,82.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M71.5,105.5c-2-2.5-3.1-5.6-3-8.8C68.5,88,76,80.5,86,80.5h18.2c1-0.1,1.8,0.7,1.9,1.7v0.1v3.1c0,0.7-0.4,1.3-1.1,1.6 l-5.6,1.7c0,0,4,2.9,4,9.5c0,7.3-6.6,14.6-17.1,14.6c-3.8,0-6.4-0.7-8-0.7c-1.4,0-3.7,1.3-3.7,3.5c0,2,1.8,3.2,4,3.2h12.8 c9.1,0,16.5,4.8,16.5,13c0,8.6-7.4,15.8-21.9,15.8c-14.8,0-20.4-6.8-20.4-12.8c0-5.6,5-8.3,6-8.8v-0.3c-1.7-0.5-7.5-3-7.5-9.8 C64,108.6,71.5,105.4,71.5,105.5 M85.8,138.2c5.6,0,9.3-2.3,9.3-5.9c0-1.7-1.4-4.6-7.3-4.6c-2.2,0-4.3,0.1-6.5,0.4 c-1.2,0.4-4.3,1.7-4.3,4.6C77,136,80.4,138.2,85.8,138.2 M86.3,103.9c3.7,0,6.7-3,6.7-6.7s-3-6.7-6.7-6.7c-3.7-0.2-6.9,2.6-7.1,6.3 c-0.2,3.7,2.6,6.9,6.3,7.1C85.8,103.9,86,103.9,86.3,103.9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.5,81.6c0-1,0.8-1.8,1.8-1.8h8c1,0,1.8,0.8,1.8,1.8v29.1c2.9-2.1,6.4-3.2,10-3.2c12,0,16.9,9.4,16.9,19v18.4 c0,1-0.8,1.8-1.8,1.8h-7.6c-1,0-1.8-0.8-1.8-1.8v-18.4c0-5.3-2.9-8.6-7.5-8.6c-4.3,0-7.3,2.9-8.2,6.8V145c0.1,0.9-0.6,1.8-1.6,1.8 c-0.1,0-0.3,0-0.4,0h-7.8c-1,0-1.8-0.8-1.8-1.8L118.5,81.6L118.5,81.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M118.2,31.2c0-1,0.9-1.8,1.9-1.8l0,0h3.8c0.8,0,1.4,0.4,1.7,1.1L127,34c3.8-3.6,8.9-5.6,14.1-5.6c12.7,0,17.8,9,17.8,18.9 v30.2c-0.1,1-0.9,1.8-1.9,1.8h-8.2c-1,0-1.9-0.8-1.9-1.8l0,0V46.8c0-4.9-1.7-8.1-6.5-8.1c-4.1-0.1-7.8,2.3-9.4,6v20.8 c0,1.3-0.6,1.8-2.5,1.8h-8.4c-1,0-1.8-0.8-1.9-1.8L118.2,31.2L118.2,31.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M167.5,110.3c0-1,0.9-1.8,1.9-1.8l0,0h8.3c1,0,1.9,0.8,1.9,1.8l0,0V145c-0.1,1-0.9,1.8-1.9,1.8h-8.3c-1,0-1.8-0.8-1.9-1.8 V110.3L167.5,110.3z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-instagram",
      "viewBox": "0 0 20 20"
    }
  }, [_c('title', [_vm._v("instagram")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 1h-14c-1.1 0-2 0.9-2 2v14c0 1.101 0.9 2 2 2h14c1.1 0 2-0.899 2-2v-14c0-1.1-0.9-2-2-2zM9.984 15.523c3.059 0 5.538-2.481 5.538-5.539 0-0.338-0.043-0.664-0.103-0.984h1.581v7.216c0 0.382-0.31 0.69-0.693 0.69h-12.614c-0.383 0-0.693-0.308-0.693-0.69v-7.216h1.549c-0.061 0.32-0.104 0.646-0.104 0.984 0 3.059 2.481 5.539 5.539 5.539zM6.523 9.984c0-1.912 1.55-3.461 3.462-3.461s3.462 1.549 3.462 3.461-1.551 3.462-3.462 3.462c-1.913 0-3.462-1.55-3.462-3.462zM16.307 6h-1.615c-0.382 0-0.692-0.312-0.692-0.692v-1.617c0-0.382 0.31-0.691 0.691-0.691h1.615c0.384 0 0.694 0.309 0.694 0.691v1.616c0 0.381-0.31 0.693-0.693 0.693z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-linkedin",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("linkedin")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 12h6v18h-6v-18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-twitter",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("twitter")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-behance",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("behance")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.281 6.412c0.944 0 1.794 0.081 2.569 0.25 0.775 0.162 1.431 0.438 1.988 0.813 0.55 0.375 0.975 0.875 1.287 1.5 0.3 0.619 0.45 1.394 0.45 2.313 0 0.994-0.225 1.819-0.675 2.481-0.456 0.662-1.119 1.2-2.006 1.625 1.213 0.35 2.106 0.962 2.706 1.831 0.6 0.875 0.887 1.925 0.887 3.163 0 1-0.194 1.856-0.575 2.581-0.387 0.731-0.912 1.325-1.556 1.781-0.65 0.462-1.4 0.8-2.237 1.019-0.831 0.219-1.688 0.331-2.575 0.331h-9.544v-19.688h9.281zM8.719 14.363c0.769 0 1.406-0.181 1.906-0.55 0.5-0.363 0.738-0.963 0.738-1.787 0-0.456-0.081-0.838-0.244-1.131-0.169-0.294-0.387-0.525-0.669-0.688-0.275-0.169-0.588-0.281-0.956-0.344-0.356-0.069-0.731-0.1-1.113-0.1h-4.050v4.6h4.388zM8.956 22.744c0.425 0 0.831-0.038 1.213-0.125 0.387-0.087 0.731-0.219 1.019-0.419 0.287-0.194 0.531-0.45 0.706-0.788 0.175-0.331 0.256-0.756 0.256-1.275 0-1.012-0.287-1.738-0.856-2.175-0.569-0.431-1.325-0.644-2.262-0.644h-4.7v5.419h4.625z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.663 22.675c0.587 0.575 1.431 0.863 2.531 0.863 0.788 0 1.475-0.2 2.044-0.6s0.913-0.825 1.044-1.262h3.45c-0.556 1.719-1.394 2.938-2.544 3.675-1.131 0.738-2.519 1.113-4.125 1.113-1.125 0-2.131-0.181-3.038-0.538-0.906-0.363-1.663-0.869-2.3-1.531-0.619-0.663-1.106-1.45-1.45-2.375-0.337-0.919-0.512-1.938-0.512-3.038 0-1.069 0.175-2.063 0.525-2.981 0.356-0.925 0.844-1.719 1.494-2.387s1.413-1.2 2.313-1.588c0.894-0.387 1.881-0.581 2.975-0.581 1.206 0 2.262 0.231 3.169 0.706 0.9 0.469 1.644 1.1 2.225 1.887s0.994 1.694 1.25 2.706c0.256 1.012 0.344 2.069 0.275 3.175h-10.294c0 1.119 0.375 2.188 0.969 2.756zM27.156 15.188c-0.462-0.512-1.256-0.794-2.212-0.794-0.625 0-1.144 0.106-1.556 0.319-0.406 0.213-0.738 0.475-0.994 0.787-0.25 0.313-0.425 0.65-0.525 1.006-0.1 0.344-0.163 0.663-0.181 0.938h6.375c-0.094-1-0.438-1.738-0.906-2.256z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.887 8h7.981v1.944h-7.981v-1.944z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-dribbble",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("dribbble")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 32c-8.825 0-16-7.175-16-16s7.175-16 16-16c8.825 0 16 7.175 16 16s-7.175 16-16 16v0zM29.494 18.188c-0.469-0.15-4.231-1.269-8.512-0.581 1.788 4.912 2.512 8.912 2.656 9.744 3.063-2.075 5.25-5.356 5.856-9.163v0zM21.337 28.6c-0.206-1.2-0.994-5.375-2.913-10.363-0.031 0.012-0.063 0.019-0.087 0.031-7.713 2.688-10.481 8.031-10.725 8.531 2.319 1.806 5.231 2.887 8.387 2.887 1.894 0 3.7-0.387 5.338-1.087v0zM5.844 25.156c0.313-0.531 4.063-6.738 11.106-9.019 0.175-0.056 0.356-0.113 0.538-0.162-0.344-0.775-0.719-1.556-1.106-2.319-6.819 2.044-13.444 1.956-14.044 1.95-0.006 0.137-0.006 0.275-0.006 0.419 0 3.506 1.331 6.712 3.512 9.131v0zM2.625 13.219c0.612 0.006 6.244 0.031 12.637-1.662-2.262-4.025-4.706-7.412-5.069-7.906-3.825 1.806-6.688 5.331-7.569 9.569v0zM12.8 2.731c0.375 0.506 2.863 3.888 5.1 8 4.863-1.819 6.919-4.588 7.163-4.938-2.413-2.144-5.587-3.444-9.063-3.444-1.1 0.006-2.175 0.138-3.2 0.381v0zM26.581 7.381c-0.288 0.388-2.581 3.325-7.631 5.388 0.319 0.65 0.625 1.313 0.906 1.981 0.1 0.238 0.2 0.469 0.294 0.706 4.55-0.569 9.069 0.344 9.519 0.438-0.031-3.225-1.188-6.188-3.087-8.512v0z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-malt",
      "viewBox": "0 0 93 93"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M34.6,79c0,7.8,5.1,12.3,11.5,12.3c0,0,0,0,0,0c6.3,0,11.5-6,11.6-12.3L46,67.3L34.6,79z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.5,12.8c-2.1-2.2-5-3.5-8.1-3.5c-3.1-0.1-6,1.1-8.2,3.2c-4.6,4.4-4.7,11.7-0.4,16.3l1.7,1.8l24.3,0.1l3.9-3.9L30.5,12.8 z M78.4,62.7l-1.7-1.8l-24.3-0.1l-3.9,3.9l13.3,13.9c4.4,4.6,11.7,4.7,16.3,0.4C82.6,74.6,82.7,67.3,78.4,62.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M79.2,34.3L55.9,57.3l24.7,0.1h0.1c3.1,0,5.9-1.2,8.1-3.3c2.2-2.1,3.4-5.1,3.4-8.1C92.2,39.6,87.2,34.2,79.2,34.3 M11.6,34 L11.6,34c-3.1,0-6,1.2-8.2,3.3C1.2,39.5,0,42.5,0,45.5c0,3.1,0.6,11.6,13.2,11.6l23.1-22.9C36.3,34.2,11.6,34,11.6,34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.9,13.2c-4.5-4.5-11.8-4.5-16.3-0.1L13.4,61.9c-4.5,4.5-4.5,11.8-0.1,16.3c4.5,4.5,11.8,4.5,16.3,0.1l49.1-48.7 C83.3,25,83.3,17.7,78.9,13.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M58.6,12.3C58.6,4.5,53.5,0,47.1,0c0,0,0,0,0,0c-6.3,0-11.5,6-11.6,12.3L47.1,24C47.1,24,58.6,12.3,58.6,12.3z"
    }
  })])]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-artstation",
      "viewBox": "0 0 105.8 93"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M0,71.8l8.9,15.4l0,0c1.8,3.5,5.4,5.9,9.5,5.9l0,0l0,0h59.3L65.4,71.8L0,71.8L0,71.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M105.8,71.9c0-2.1-0.6-4.1-1.7-5.8L69.3,5.7C67.5,2.3,64,0,59.9,0H41.5l53.7,93l8.5-14.7C105.3,75.5,105.8,74.3,105.8,71.9z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "56.7,56.6 32.8,15.1 8.8,56.6"
    }
  })])]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "fany-righi",
      "viewBox": "0 0 212.9 175.6"
    }
  }, [_c('g', {
    staticClass: "Defs-strokes",
    attrs: {
      "clip-path": "url(#fany-righi-clip-path)"
    }
  }, [_c('line', {
    staticClass: "f1",
    attrs: {
      "x1": "33.1",
      "y1": "34.3",
      "x2": "62.8",
      "y2": "34.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "f2",
    attrs: {
      "d": "M67.7,8.7c0,0-23.3-11.3-23.3,10.4s0,48.2,0,48.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "a1",
    attrs: {
      "d": "M76.1,35c3.9-1.1,8.8-2,12.9-2c11,0,13.5,5.4,13.5,14.5v19.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "a2",
    attrs: {
      "d": "M97.7,49.1c0,0-3.1-2.1-7.7-2.1c-8,0-12.6,3.6-12.6,8.2c0,5.5,4.4,8.8,10.7,8.8c3.5,0,7-1.2,9.6-3.3"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "n1",
    attrs: {
      "x1": "121.9",
      "y1": "29.4",
      "x2": "124.4",
      "y2": "67.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "n2",
    attrs: {
      "d": "M127,40.8c3.1-3.2,7.3-6.9,11.6-6.9c10.5,0,14.6,8,14.6,16.8v28.6"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "y1",
    attrs: {
      "x1": "172.6",
      "y1": "26.6",
      "x2": "190.3",
      "y2": "62.6"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "y2",
    attrs: {
      "x1": "208",
      "y1": "26.6",
      "x2": "172.2",
      "y2": "99.3"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "h1",
    attrs: {
      "x1": "124.2",
      "y1": "79.8",
      "x2": "124.2",
      "y2": "146.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "h2",
    attrs: {
      "d": "M126.3,122.3c2-5,6.1-9.9,11.9-9.9c9.6,0,13.6,7.5,13.6,15.1v19.3"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "i2",
    attrs: {
      "x1": "173.5",
      "y1": "108.5",
      "x2": "173.5",
      "y2": "146.8"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "Defs-strokes Defs-rig",
    attrs: {
      "clip-path": "url(#fany-righi-clip-path)"
    }
  }, [_c('line', {
    staticClass: "r1",
    attrs: {
      "x1": "3.7",
      "y1": "109.5",
      "x2": "5.8",
      "y2": "148.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "r2",
    attrs: {
      "d": "M8.9,119.6c2.6-3.7,6.8-5.9,11.3-6c2.5,0,4.9,0.4,6.4,1.2"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "i1",
    attrs: {
      "x1": "44.4",
      "y1": "108.5",
      "x2": "44.4",
      "y2": "148.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "g1",
    attrs: {
      "d": "M106.1,111.6l-19,1.6c-6.6,0-13.2,5.2-13.2,11.6s5.3,11.6,11.9,11.6c6.6,0.3,12.2-4.5,12.6-10.9 s-4.7-11.9-11.3-12.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "g2",
    attrs: {
      "d": "M79.2,133.6c-0.5,0.1-9.9,4.2-9.9,10.3c0,5.8,9.2,7.2,12,7.2c1.9,0,6.7,0,6.7,0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "g3",
    attrs: {
      "d": "M86.7,151.1c8.9,0,14.5,4.1,14.5,10.2c0,3-1.6,5.1-3.3,6.5c-1.7,1.4-3.9,2.2-6.1,2.4c-2.8,0.3-5.5,0.4-8.4,0.4 c-9.7,0-12-5.4-12-8.6C71.4,155.4,77.5,151.1,86.7,151.1"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "Defs-strokes Defs-rig-ms",
    attrs: {
      "clip-path": "url(#fany-righi-clip-path-ms)"
    }
  }, [_c('line', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "x1": "3.7",
      "y1": "81.5",
      "x2": "5.8",
      "y2": "120.5"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "d": "M8.9,91.6c2.6-3.7,6.8-5.9,11.3-6c2.5,0,4.9,0.4,6.4,1.2"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "x1": "44.4",
      "y1": "80.5",
      "x2": "44.4",
      "y2": "120.5"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "d": "M86.7,123.1c8.9,0,14.5,4.1,14.5,10.2c0,3-1.6,5.1-3.3,6.5c-1.7,1.4-3.9,2.2-6.1,2.4 c-2.8,0.3-5.5,0.4-8.4,0.4c-9.7,0-12-5.4-12-8.6C71.4,127.4,77.5,123.1,86.7,123.1"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "d": "M79.2,105.6c-0.5,0.1-9.9,4.2-9.9,10.3c0,5.8,9.2,7.2,12,7.2c1.9,0,6.7,0,6.7,0"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "d": "M106.1,83.6l-19,1.6c-6.6,0-13.2,5.2-13.2,11.6s5.3,11.6,11.9,11.6c6.6,0.3,12.2-4.5,12.6-10.9 s-4.7-11.9-11.3-12.3"
    }
  })])]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-quote",
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.305,13.096c3.741,0,6.775,3.033,6.775,6.775s-3.033,6.775-6.775,6.775 c-3.741,0-6.775-3.033-6.775-6.775L0.5,18.903c0-7.483,6.066-13.549,13.549-13.549v3.871c-2.585,0-5.015,1.007-6.843,2.835 c-0.352,0.352-0.673,0.726-0.963,1.12C6.589,13.125,6.944,13.096,7.305,13.096 M24.725,13.096c3.741,0,6.775,3.033,6.775,6.775 s-3.033,6.775-6.775,6.775c-3.741,0-6.774-3.033-6.774-6.775l-0.03-0.968c0-7.483,6.066-13.549,13.549-13.549v3.871 c-2.585,0-5.016,1.007-6.844,2.835c-0.352,0.352-0.673,0.726-0.963,1.12C24.01,13.125,24.364,13.096,24.725,13.096"
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f146c9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 215
// module chunks = 0